import { AxiosResponse } from 'axios'
import { UpdateBody } from 'types/common'
import { api } from 'API'
import { MediaType } from 'constants/media'
import { IMedia } from 'interfaces/media'

export async function updateMediaById(id: number, updateBody: UpdateBody<IMedia>): Promise<void> {
  await api.patch(`/media/${id}`, updateBody)
}

// Returns the created row: a caller that has to attach the upload to something
// else (an Instruction) needs its id, and there is no other way to get it.
export async function createMedia(media: UpdateBody<IMedia>): Promise<IMedia> {
  const response = await api.post('/media', media)
  return response.data
}

export async function deleteMediaById(id: number): Promise<void> {
  await api.delete(`/media/${id}`)
}

export async function dropMediaType(mediaType: MediaType, stepId?: number, processId?: number): Promise<void> {
  await api.put(`/media/drop`, { mediaType, stepId, processId })
}

export async function createManyMedias(medias: UpdateBody<IMedia>[]): Promise<IMedia[]> {
  const response: AxiosResponse = await api.post(`/media/create-many`, medias)
  return response.data
}
